module.exports = __webpack_public_path__ + "img/T2A_rc_0.e5f4fc42.png";